export default "__VITE_ASSET__DaOTRAEC__"